import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CoachingRoutingModule} from './coaching-routing.module';
import {CoachingTeamComponent} from './coaching-team/coaching-team.component';
import {CoachingFormComponent} from './coaching-form/coaching-form.component';
import {ComponentsModule} from '../components/components.module';
import {RatingComponent} from './coaching-form/rating/rating.component';
import {TranslateModule} from '@ngx-translate/core';
import {CoachingReportComponent} from './coaching-report/coaching-report.component';
import {CoachingCommentsComponent} from './coaching-comments/coaching-comments.component';
import {CoachingReportSingleComponent} from './coaching-report/report/coaching-report-single.component';
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CoachingRoutingModule,
        ComponentsModule,
        TranslateModule.forChild(),
        NgSelectModule
    ],
    declarations: [
        RatingComponent,
        CoachingTeamComponent,
        CoachingFormComponent,
        CoachingReportComponent,
        CoachingReportSingleComponent,
        CoachingCommentsComponent,
    ]
})
export class CoachingModule {
}
